<template>
  <div class="tag-box">
    <div class="action-bar">
      <!-- <el-input
        placeholder="请输入Id"
        v-model="params.id"
        clearable
        size="small"
        class="param-input"
      ></el-input> -->
      <el-select v-model="params.type" size="small" placeholder="请选择类型" clearable>
        <el-option :value="1" label="AI视频换脸"></el-option>
        <el-option :value="2" label="AI图片换脸"></el-option>
      </el-select>
      <el-select v-model="params.status" size="small" placeholder="请选择类型" clearable>
        <el-option :value="1" label="开启"></el-option>
        <el-option :value="2" label="关闭"></el-option>
      </el-select>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getDataList"
        style="margin-right: 20px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="addAndEdit('add', {})"
        style="margin-right: 20px"
        >新增</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      ref="multipleTable"
      height="600"
      >
      <el-table-column prop="id" label="ID" align="center" min-width="210" />
      <el-table-column prop="name" label="名称" align="center" min-width="210" />
      <el-table-column prop="status" label="状态" align="center" min-width="210">
        <template slot-scope="scope">
          {{ scope.row.status == 1 ? '开启' : '关闭' }}
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" align="center" min-width="210">
        <template slot-scope="scope">
          {{ scope.row.type == 1 ? 'AI视频换脸' : 'AI图片换脸' }}
        </template>
      </el-table-column>
      <el-table-column prop="sortNum" label="排序" align="center" min-width="210" />
      <el-table-column
        label="操作"
        align="center"
        min-width="180"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="addAndEdit('edit', scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="del(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <editOrAdd ref="editOrAddRef" @reloadpage="getDataList" />
  </div>
</template>
<script>

import editOrAdd from "./editOrAdd.vue";
import voteApi from "@/api/ai";
export default {
  components: { editOrAdd },
  data() {
    return {
      tableData: [],
      params: {
        pageNumber: 1,
        pageSize: 10,
      },
      total: 0
    }
  },
  mounted() {
    this.getDataList()
  },
  methods: {
    async getDataList() {
      const data = await voteApi.getTemplateList({
        ...this.params,
        ...this.form
      })
      this.tableData = data.data.list || []
      this.total = data.data.total
    },
    addAndEdit(type, data) {
      this.$refs.editOrAddRef.open(type, data)
    },
    del(data) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        voteApi.deleteTemplate({
          id: data.id
        }).then(() => {
          this.getDataList()
        })
      })
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getDataList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getDataList();
    },
  }
}
</script>